import { SubjectPermissionTable } from './SubjectPermissionTable';
export default SubjectPermissionTable;